<template>
  <router-view v-slot="{ Component }">
    <component :is="Component"/>
  </router-view>
</template>

<script setup>
import {onMounted} from 'vue';

onMounted(() => {
  window.addEventListener('resize', () => {
    const isPortrait = window.innerHeight > window.innerWidth;
    if (isPortrait && this.$route.path === '/') {
      this.$router.push('/indexApp');
    } else if (!isPortrait && this.$route.path === '/indexApp') {
      this.$router.push('/');
    }
  });
})
</script>

<style lang="scss" scoped>
body {
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>